import { Line } from "react-chartjs-2";
import type { ChartOptions, ScriptableContext } from "chart.js";

interface LineChartProps {
	labels: string[];
	chartData: number[];
}

function LineChart({ labels, chartData }: LineChartProps) {
	const data = {
		labels,
		datasets: [
			{
				label: "Revenue",
				data: chartData,
				borderColor: "#3498DB",
				fill: true,
				backgroundColor: (context: ScriptableContext<"line">) => {
					const gradient = context.chart.ctx.createLinearGradient(
						0,
						0,
						0,
						context.chart.height,
					);
					gradient.addColorStop(0, "#3498DB44");
					gradient.addColorStop(1, "#3498DB00");
					return gradient;
				},
				borderWidth: 3,
				tension: 0.3,
			},
		],
	};

	const options: ChartOptions<"line"> = {
		plugins: {
			title: {
				display: false,
			},
			legend: {
				display: false,
			},
		},
		maintainAspectRatio: false,
		scales: {
			x: {
				grid: { display: false },
			},
			y: {
				grid: { color: "#d8d8d844" },
				border: { display: false },
			},
		},
	};

	return <Line data={data} options={options} />;
}
export default LineChart;
